import { VaultRequestError } from '@cef-ai/vault-sdk';

// Outcome of `vault.agents.connect` when followed by a UI redirect. Both
// "success" and "already-connected" are positive terminal states: the user
// has the agent in their vault, just on different paths. The marketplace
// distinguishes them so it can deep-link an already-connected agent to
// /vault/agents/<id> instead of dumping the user back on the vault index.
export type ConnectFollowup =
  | { kind: 'success' }
  | { kind: 'already-connected' }
  | { kind: 'error'; message: string };

export function decideConnectFollowup(e: unknown): ConnectFollowup {
  if (e instanceof VaultRequestError) {
    // The new SDK collapsed `VaultAgreementConflictError` into a generic
    // `VaultRequestError` with status 409. Treat it as success — the user
    // has already accepted the agreement for this (agent, vault, scope).
    if (e.status === 409) return { kind: 'success' };
    if (e.code === 'AGENT_ALREADY_CONNECTED') return { kind: 'already-connected' };
  }
  return { kind: 'error', message: e instanceof Error ? e.message : String(e) };
}
